import colors from './partials/colors';
import constants from './partials/constants';
import device from './partials/device';
import { fonts } from './partials/fonts';
import { mixin } from './partials/mixin';
import zIndex from './partials/zIndex';

function theme(themeColor) {
  const themeColors = colors(themeColor);

  return {
    colors: themeColors,
    device,
    constants,
    fontset: fonts,
    zindex: zIndex,
    mixin
  };
}

export default theme;
